import clsx from 'clsx';

import { last } from 'lodash';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import LinkTo from '@/components/LinkTo';

const Tabs = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const route = last(router.asPath.split('/'));

  return (
    <section className="section">
      <div className="flex justify-center items-center space-x-6 border-b border-gray-300">
        <LinkTo
          href="/contacts"
          aria-label={t('CONTACT_US_PRIVATE')}
          className={clsx('text-xl text-black p-6 md:p-8', {
            'font-bold border-b-2 border-black': route === 'contacts'
          })}
        >
          {t('CONTACT_US_PRIVATE')}
        </LinkTo>

        <LinkTo
          href="/b2bcontacts"
          aria-label={t('CONTACT_US_B2B')}
          className={clsx('text-xl text-black p-6 md:p-8', {
            'font-bold border-b-2 border-black': route === 'b2bcontacts'
          })}
        >
          {t('CONTACT_US_B2B')}
        </LinkTo>

        <LinkTo
          href="/press-contacts"
          aria-label={t('CONTACT_US_PRESS')}
          className={clsx('text-xl text-black p-6 md:p-8', {
            'font-bold border-b-2 border-black': route === 'press-contacts'
          })}
        >
          {t('CONTACT_US_PRESS')}
        </LinkTo>
      </div>
    </section>
  );
};

export default Tabs;
